import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackGA4PageView } from '../utilities/googleAnalyticsUtils';

/**
 * PageTracker Component
 * Automatically tracks page views whenever the route changes
 * Must be placed inside a Router component
 */
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Normalize pathname (remove trailing slash for consistency, except for root)
    const normalizePath = (pathname) => {
      if (pathname === '/') return '/';
      return pathname.replace(/\/$/, '');
    };

    // Get the page name based on the pathname
    const getPageName = (pathname) => {
      if (pathname === '/') return 'Home';
      if (pathname.startsWith('/admin/login')) return 'Admin Login';
      if (pathname.startsWith('/admin/dashboard')) return 'Admin Dashboard';
      if (pathname.startsWith('/blog/')) return 'Blog Post';
      return pathname;
    };

    const normalizedPath = normalizePath(location.pathname);
    const pageName = getPageName(normalizedPath);
    
    // Track the page view with normalized path
    trackGA4PageView(normalizedPath, pageName);
  }, [location.pathname]); // Only re-run when pathname changes

  return null; // This component doesn't render anything
};

export default PageTracker;
